import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppTerminal } from 'application/components/api/EppTerminal';

export const eppTerminalAdapter = createEntityAdapter<IEppTerminal, number>({
  selectId: (project) => project.eppTerminalID,
});
